export const MONTHS = [
    {
        name: {
            short: 'Jan',
            full: 'January',
        },
        color: '#637bfe',
    },
    {
        name: {
            short: 'Feb',
            full: 'February',
        },
        color: '#33bfff',
    },
    {
        name: {
            short: 'Mar',
            full: 'March',
        },
        color: '#1de9b6',
    },
    {
        name: {
            short: 'Apr',
            full: 'April',
        },
        color: '#00e676',
    },
    {
        name: {
            short: 'May',
            full: 'May',
        },
        color: '#ade470',
    },
    {
        name: {
            short: 'Jun',
            full: 'June',
        },
        color: '#ffc400',
    },
    {
        name: {
            short: 'Jul',
            full: 'July',
        },
        color: '#ff9100',
    },
    {
        name: {
            short: 'Aug',
            full: 'August',
        },
        color: '#ff6333',
    },
    {
        name: {
            short: 'Sep',
            full: 'September',
        },
        color: '#ff4569',
    },
    {
        name: {
            short: 'Okt',
            full: 'October',
        },
        color: '#f73378',
    },
    {
        name: {
            short: 'Nov',
            full: 'November',
        },
        color: '#dd33fa',
    },
    {
        name: {
            short: 'Dec',
            full: 'December',
        },
        color: '#834bff',
    }
];
export const ROOT_CLASS = 'date-picker';
export const MIN_SWIPE = 100;
